import styled from 'styled-components'

type TabStyledProps = {
  isActive: boolean
}

export const TabContainer = styled.div<TabStyledProps>`
  display: flex;
  align-items: center;
  gap: ${({ theme: { layout } }) => layout.spacing(1)};
  min-height: ${({ theme: { layout } }) => layout.spacing(7)};
  padding: ${({ theme: { layout } }) => `${layout.spacing(2)} ${layout.spacing(3)}`};
  background: ${({ isActive, theme }) =>
    isActive ? theme.colors.backgroundContent : theme.colors.backgroundTab};
  color: ${({ isActive, theme }) => (isActive ? theme.colors.text : theme.colors.textOpposite)};
  line-height: ${({ theme: { layout } }) => layout.spacing(3)};
  cursor: pointer;
  &:focus {
    outline: none;
  }
`
